import { getFromLocalStorage, setToLocalStorage } from './storage'

const MAX_QUEUE_SIZE = 5

export const setListAdResponse = (data) => setToLocalStorage('listAdResponse', data)

export const getListAdResponse = () => getFromLocalStorage('listAdResponse')

export const pushQueue = (item) => {
  const listAdResponses = getListAdResponse() || []
  listAdResponses.push(item)
  setListAdResponse(listAdResponses)
}

export const getFirstQueuedItem = () => {
  const listAdResponses = getListAdResponse() || []
  return listAdResponses.length > 0 ? listAdResponses[0] : null
}

export const getLastQueuedItem = () => {
  const listAdResponses = getListAdResponse() || []
  return listAdResponses.length > 0 ? listAdResponses[listAdResponses.length - 1] : null
}

export const removeFirstQueuedItem = () => {
  const listAdResponses = getListAdResponse() || []
  // sisakan satu ad data
  if (listAdResponses.length > 1) {
    listAdResponses.shift()
    setListAdResponse(listAdResponses)
  }
}

export const isQueueFull = () => {
  const listAdResponses = getListAdResponse() || []
  return listAdResponses.length >= MAX_QUEUE_SIZE
}
